module.exports = __webpack_public_path__ + "static/media/live-chat-icon-white.819ebf17.svg";